import React from 'react';
import { Link } from 'react-router-dom';
import './KidsCookoff.css';


import { 
  FaBaby, 
  FaDollarSign, 
  FaTrophy, 
  FaFire,
  FaCertificate,
  FaCameraRetro,
  FaHeart,
  FaUsers,
  FaCalendarAlt,
  FaInfoCircle
} from 'react-icons/fa';

import { GiBarbecue } from 'react-icons/gi';

const KidsCookoff = () => {
  return (
    <div className="kids-container">
      
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <h1>
            <FaBaby className="hero-icon" />
            Junior Pitmasters Challenge
            <FaBaby className="hero-icon" />
          </h1>
          <p className="hero-subtitle">
            A fun and friendly competition for young BBQ enthusiasts to show off their skills!
          </p>
        </div>
      </div>

      
      <div className="info-card">
        <GiBarbecue className="card-icon" />
        <div className="card-content">
          <h2>Competition Details</h2>
          <div className="details-grid">
            <div className="detail-item">
              <FaDollarSign className="detail-icon" />
              <div className="detail-info">
                <span className="detail-label">Entry Fee</span>
                <span className="detail-value">$25 per participant</span>
              </div>
            </div>
            <div className="detail-item">
              <FaUsers className="detail-icon" />
              <div className="detail-info">
                <span className="detail-label">Age Divisions</span>
                <div className="age-divisions">
                  <div className="age-group">
                    <span className="age-range">Junior (Ages 5–10)</span>
                  </div>
                  <div className="age-group">
                    <span className="age-range">Senior (Ages 11–17)</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-item">
              <FaCalendarAlt className="detail-icon" />
              <div className="detail-info">
                <span className="detail-label">Turn-in Times</span>
                <span className="detail-value">
                  <FaInfoCircle className="info-icon" />
                  Will be announced soon
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <div className="info-card prize-card">
        <FaTrophy className="card-icon" />
        <div className="card-content">
          <h2>Prizes (Per Age Group)</h2>
          <p className="prize-explanation">Prize pool grows with participation - the more kids that sign up, the bigger the prizes!</p>
          <div className="prizes-grid">
            <div className="prize-item first">
              <FaTrophy className="prize-icon" />
              <span className="prize-place">1st Place</span>
              <span className="prize-amount">50% of Pool</span>
            </div>
            <div className="prize-item second">
              <FaTrophy className="prize-icon" />
              <span className="prize-place">2nd Place</span>
              <span className="prize-amount">30% of Pool</span>
            </div>
            <div className="prize-item third">
              <FaTrophy className="prize-icon" />
              <span className="prize-place">3rd Place</span>
              <span className="prize-amount">20% of Pool</span>
            </div>
          </div>
          <div className="prize-examples">
            <h4>Prize Examples:</h4>
            <div className="example-row">
              <span>10 kids sign up = $250 total pool</span>
              <span>1st: $125 | 2nd: $75 | 3rd: $50</span>
            </div>
            <div className="example-row">
              <span>20 kids sign up = $500 total pool</span>
              <span>1st: $250 | 2nd: $150 | 3rd: $100</span>
            </div>
          </div>
          <div className="participation-note">
            <FaCertificate className="certificate-icon" />
            <span>All participants will receive a certificate of participation!</span>
          </div>
        </div>
      </div>

      
      <div className="cta-section">
        <div className="cta-content">
          <h3>Ready to Register Your Young Pitmaster?</h3>
          <p>Join the fun and let your child showcase their BBQ skills!</p>
          <Link to="/register" className="btn btn-primary">
            <FaFire className="btn-icon" />
            Register Your Child
            <span className="btn-arrow">→</span>
          </Link>
        </div>
      </div>

      
      <div className="info-card gallery-card">
        <FaCameraRetro className="card-icon" />
        <div className="card-content">
          <h2>Photo Gallery</h2>
          <div className="gallery-placeholder">
            <FaHeart className="gallery-icon" />
            <p>Check back later for photos from the event!</p>
            <p className="gallery-description">
              We'll be capturing all the amazing moments from our young pitmasters in action.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KidsCookoff; 